<div class="resize-tracker" #resize></div>
<div class="footer-container" [style.width]="`${resizedBorderBoxWidth()}px`">
  <div class="footer-content-container">
    <ng-content></ng-content>
  </div>
</div>
